import { Request } from '@/classes/Request'

/**
 * Refresh Authorize.Net-saved funding sources after the hosted form returns,
 * token-authenticated.
 * GET /api/enrollment/invitation/{token}/funding-sources/sync
 */
export const enrollmentSyncFundingSources = async (token: string): Promise<void> => {
  await new Request().get(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/funding-sources/sync`
  )
}
